import { render, staticRenderFns } from "./BillingSequences.vue?vue&type=template&id=45b236cc&scoped=true"
import script from "./BillingSequences.vue?vue&type=script&lang=js"
export * from "./BillingSequences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b236cc",
  null
  
)

export default component.exports